module.exports = __webpack_public_path__ + "3-suBAXl.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/calendar.png
// module id = ./src/img/calendar.png
// module chunks = main